import type { TrellusHostClient } from './host-client';

/**
 * The one live Trellus client for this document, published by
 * `startTrellusHost()` (see `host-events-bridge.ts`) and consumed by the
 * sidebar actions and the selection-broadcast hook. Null when no extension
 * connection has been started — every consumer treats that as "Trellus
 * absent": no-op, Clay unaffected.
 */
let active: TrellusHostClient | null = null;

export function getActiveTrellusClient(): TrellusHostClient | null {
  return active;
}

export function setActiveTrellusClient(client: TrellusHostClient | null): void {
  active = client;
}
